var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionmark = function SvgQuestionmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.806 17.408c3.486-.231 6.263-3.047 6.491-6.583.045-.691.045-1.408 0-2.1-.228-3.535-3.005-6.351-6.49-6.583a28 28 0 0 0-3.618 0c-3.486.232-6.263 3.048-6.491 6.583a16.5 16.5 0 0 0 0 2.1c.083 1.288.652 2.48 1.323 3.487.389.705.132 1.584-.273 2.353-.293.553-.439.83-.322 1.03.118.2.38.207.904.22 1.037.025 1.736-.269 2.291-.678.315-.232.472-.348.58-.362.11-.013.323.075.75.25.383.159.829.256 1.238.283a28 28 0 0 0 3.617 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M8.75 7.949c0-.708.56-1.282 1.25-1.282s1.25.574 1.25 1.282a1.3 1.3 0 0 1-.198.693C10.678 9.237 10 9.805 10 10.513v.32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 12.5h.008"
  })));
};
export default SvgQuestionmark;